import React, { useEffect, useState } from "react";
import { Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import { CstmPagination } from "../../../../components/Common/Common";

// img
import { Link } from "react-router-dom";
import BookingReportTab from "./tabbed/BookingReportTab";
import BookingStatusTab from "./tabbed/BookingStatus";
import RevenueReport from "./tabbed/RevenueReport";
import { toast } from "react-toastify";
import { GET_DASHBOARD_DATA } from "../../../../services/ApiCalls";
import moment from "moment";
import {
  GroupByFilterOptionArr,
  statusFilterOptionArr,
} from "../../../../utilities/const";

const BookingReport = () => {
  const [bookingReport, setBookingReport] = useState();
  const [body, setBody] = useState({
    groupBy: "days",
  });

  const bookingReportData = async (body) => {
    try {
      const today = moment().format("DD-MM-YYYY");

      const tomorrow = moment().add(1, "days").format("DD-MM-YYYY");

      const dashboardRes = await GET_DASHBOARD_DATA(body);
      if (dashboardRes?.data?.status === "success") {
        setBookingReport(dashboardRes?.data?.data);
      } else {
        toast.error(dashboardRes?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    bookingReportData(body);
  }, [body.groupBy]);

  return (
    <>
      <section className="report py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="BookingReports"
              >
                <div className="d-flex justify-content-between">
                  <Nav
                    variant="pills"
                    className="underlineTab border-bottom justify-content-center mb-3"
                    style={{ maxWidth: "max-content" }}
                  >
                    <Nav.Item style={{ minWidth: 150 }}>
                      <Nav.Link
                        eventKey="BookingReports"
                        className="bg-transparent position-relative fw-sbold text-center"
                      >
                        Booking Reports
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item style={{ minWidth: 150 }}>
                      <Nav.Link
                        eventKey="BookingStatus"
                        className="bg-transparent position-relative fw-sbold text-center"
                      >
                        Booking Status
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item style={{ minWidth: 150 }}>
                      <Nav.Link
                        eventKey="RevenueReport"
                        className="bg-transparent position-relative fw-sbold text-center"
                      >
                        Revenue Report
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  {/* <li className="d-flex align-items-center gap-10">
                    <label
                      htmlFor=""
                      className="form-label m-0 text-muted "
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      Group by
                    </label>
                    <Form.Select
                      aria-label="Default select example"
                      className=" form-control"
                      defaultValue={body.groupBy}
                      onChange={(e) =>
                        setBody((p) => ({
                          ...p,
                          groupBy: e.target.value,
                        }))
                      }
                    >
                      {GroupByFilterOptionArr?.map((option) => (
                        <option value={option.value}>{option.label}</option>
                      ))}
                    </Form.Select>
                  </li> */}
                </div>

                <Tab.Content className="pt-4">
                  <Tab.Pane eventKey="BookingReports">
                    <BookingReportTab bookingReport={bookingReport} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="BookingStatus">
                    <BookingStatusTab
                      cancelBooking={bookingReport?.cancelledBookingsCount || 0}
                      ongoingBooking={bookingReport?.activeBookingsCount || 0}
                      completeBooking={
                        bookingReport?.completedBookingsCount || 0
                      }
                      upcomingBooking={bookingReport?.pendingBookingsCount || 0}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="RevenueReport">
                    <RevenueReport bookingReport={bookingReport} />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BookingReport;
